import { ReactNode } from "react";
import {
  ConversationDetailsContext,
  EmailReplyProvider,
  IConversationDetailsContext,
  IEmailReplyContext,
  IPhoneReplyContext,
  ITextReplyContext,
  PhoneReplyProvider,
  TextReplyProvider
} from "./context";

interface ConversationPaneProvidersProps {
  conversationDetailsValue: IConversationDetailsContext;
  emailReplyValue: IEmailReplyContext;
  textReplyValue: ITextReplyContext;
  phoneReplyValue: IPhoneReplyContext;
  children: ReactNode;
}

export function ConversationPaneProviders({
  conversationDetailsValue,
  emailReplyValue,
  textReplyValue,
  phoneReplyValue,
  children
}: ConversationPaneProvidersProps) {
  return (
    <ConversationDetailsContext.Provider value={conversationDetailsValue}>
      <PhoneReplyProvider value={phoneReplyValue}>
        <TextReplyProvider value={textReplyValue}>
          <EmailReplyProvider value={emailReplyValue}>
            {children}
          </EmailReplyProvider>
        </TextReplyProvider>
      </PhoneReplyProvider>
    </ConversationDetailsContext.Provider>
  );
}

export default ConversationPaneProviders;
